<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="COPYRIGHT">First edition © 1991 Wm. B. Eerdmans Publishing Co.<br/>Second edition © 2004 Wm. B. Eerdmans Publishing Co.<br/>This third edition © 2014 Daniel L. Migliore<br/>All rights reserved<br/><br/>Published 2014 by<br/>Wm. B. Eerdmans Publishing Co.<br/>2140 Oak Industrial Drive N.E., Grand Rapids, Michigan 49505 /<br/>P.O. Box 163, Cambridge CB3 9PU U.K.<br/><br/>Printed in the United States of America</p>
<p class="LIBRARY">Library of Congress Cataloging-in-Publication Data</p>
<p class="CIP">Migliore, Daniel L., 1935- author.<br/>Faith seeking understanding: an introduction to Christian theology /<br/>Daniel L. Migliore. — Third edition.<br/>pages   cm<br/>ISBN 978-0-8028-7185-5 (pbk.: alk. paper)<br/>ISBN 978-1-4674-4221-3 (ePub)<br/>ISBN 978-1-4674-4187-2 (Kindle)<br/>1. Theology, Doctrinal. I. Title.<br/><br/>BT65.M54 2014<br/>230 — dc23<br/>                       2014012176</p>
<p class="URL"><a href="http://www.eerdmans.com" target="_blank">www.eerdmans.com</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Copyright.vue?2ae05225